// removed by extract-text-webpack-plugin
module.exports = {"input":"_index__input___1HBXO","large":"_index__large___1fMaV","fill":"_index__fill___1whSy","label":"_index__label___3X36M","demo":"_index__demo___26vJK","demoHeading":"_index__demo__heading___1xrtb","demoHeadingToggle":"_index__demo__heading--toggle___2wU6r","demoHeadingToggleClosed":"_index__demo__heading--toggle--closed___1ibMh","demoNumber":"_index__demo__number___1VjPq"};


//////////////////
// WEBPACK FOOTER
// ./src/js/_entrypoints/options-page/_index.scss
// module id = 174
// module chunks = 1